import {Component, Input} from '@angular/core';
import {ActivityStatus} from '../../domain/activity-status.model';
import {
  PublisherAdUnitRequestStatus,
  PublisherAdUnitRequestStatusLabels
} from '../../domain/publisher-ad-unit-request-status.enum';

@Component({
  selector: 'cm-publisher-request-status-plate',
  template: `
    <span
      [ngClass]="{
        'approved': status === PublisherAdUnitRequestStatus.APPROVED
       , 'rejected': status === PublisherAdUnitRequestStatus.REJECTED}">
      {{PublisherAdUnitRequestStatusLabels[status]}}
  </span>`
})
export class PublisherRequestStatusPlateComponent {

  @Input()
  public status: PublisherAdUnitRequestStatus;

  public PublisherAdUnitRequestStatus = PublisherAdUnitRequestStatus;
  public PublisherAdUnitRequestStatusLabels = PublisherAdUnitRequestStatusLabels;

}
